/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { RightPanel } from "../../components/RightPanel/RightPanel";
import { RoleBasedCustomButton } from "../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Box,
  Rating,
  Collapse,
  MenuItem,
  InputLabel,
  InputAdornment,
} from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormControl,
  CustomFormLabel,
  CustomSelect,
  CustomTextField,
} from "../../components/formsComponents";
import { CountryCodeSelector } from "../../components/CountrySelector";
import { COUNTRIES } from "../../constants/countries";
import { useAuth } from "../../contexts/AuthProvider";
import { PageTitleBar } from "../../components/PageTitleBar/PageTitleBar";
import {
  fetchStudentAsync,
  upsertStudentAysnc,
} from "../../redux/student/studentActions";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState, MODULE_IDS } from "../../constants/enums";
import { CustomDatePicker } from "../../components/formsComponents/CustomDatePicker";
import { defaultStudent } from "../../redux/student/studentState";
import { useBillingCompanyContext } from "../../providers";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import PeopleIcon from "@mui/icons-material/People";
import StarIcon from "@mui/icons-material/Star";
import { ICustomerRelationEvent, IStudent } from "../../redux/student/student.types";
import { EventAutoSearch } from "../../components/AutoCompleteSearches/EventAutoSearch";
import { StandardCard } from "../../components/Cards";
import {
  ContentCopy,
  ExpandLess,
  ExpandMore,
  Search,
} from "@mui/icons-material";
import { LocationAutoCompleteWithManualAddress } from "../../components/LocationAutoComplete/LocationAutoCompleteWithManualAddress";
import { ILocationResponsePayload } from "../../components/LocationAutoComplete/LocationAutoComplete";
import { renderDropdownValue } from "../../helpers";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { PhoneTextField } from "../../components/PhoneTextField/PhoneTextField";
import { showMessage } from "../../redux/messages/messagesActions";
import RelationAutoSearch from "../../components/AutoCompleteSearches/RelationAutoSearch";
import { GuestContactNumberAutoSearch } from "../../components/AutoCompleteSearches/GuestContactNumberAutosearch";
import { formatCompanyAddress } from "../../helpers/formatCompanyAddress";
import { useTheme, useMediaQuery } from "@mui/material";

import { GuestInteractionStatusOptions } from "../../constants/constants";
import { validatePhoneNumber } from "../../constants/phoneConfig";
import { IAddressDetails } from "../Chatbot/components/MapPicker";
import produce from "immer";

type SectionKey = "basic" | "address" | "relations" | "ratings" | null;

interface IEditCustomerProps {
  open: boolean;
  customer_id?: string;
  contact_number?: string;
  onClose: () => void;
  onComplete: () => void;
  changeTab?: (value: number) => void;
}

export const EditCustomerRightPanel: React.FC<IEditCustomerProps> = ({
  open,
  customer_id: propCustomerId,
  contact_number,
  onClose,
  onComplete,
  changeTab,
}) => {
  const { id } = useParams<{ id?: string }>();
  const customerId = propCustomerId || id;

  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.student.student,
  );

  const [saveLoading, setSaveLoading] = React.useState(false);
  const [buttonClicked, setButtonClicked] = React.useState<string | null>(null);
  const [rating, setRating] = React.useState<number>(0);
  const [relations, setRelations] = React.useState<ICustomerRelationEvent[]>(
    [],
  );
  const [openSection, setOpenSection] = React.useState<SectionKey>("basic");

  const toggleSection = (section: SectionKey) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePhoneTextFieldChange = (fieldName: string) => (value: string) => {
    setFieldValue(fieldName, value);
  };

  const handleCopyPhoneNumber = async (
    phoneNumber: string,
    _countryCode?: string,
  ) => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      dispatch(
        showMessage({
          type: "success",
          displayAs: "snackbar",
          message: "Phone number copied to clipboard!",
        }),
      );
    } catch (error) {
      dispatch(
        showMessage({
          type: "error",
          displayAs: "snackbar",
          message: "Failed to copy phone number",
        }),
      );
    }
  };

  const handleCompanyAddressChange = (data: ILocationResponsePayload) => {
    setFieldValue("address_line1", data.address_line1 || "");
    setFieldValue("address_line2", data.address_line2 || "");
    setFieldValue("city", data.city || "");
    setFieldValue("state", data.state || "");
    setFieldValue("country", data.country || "");
    setFieldValue("pincode", data.postal_code || "");
  };

  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const company = useBillingCompanyContext();
  const { country } = useAuth();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
  } = useFormik<IStudent>({
    enableReinitialize: true,
    initialValues: {
      ...(customerId
        ? { ...data, customer_fact_uuid: customerId }
        : contact_number
          ? data
          : defaultStudent),
      country_code: data?.country_code || country.dialCode,
      country_iso_code: data?.country_iso_code || country.code,
      additional_fields: {
        anniversary: "",
        spouse_name: "",
        spouse_birthday: "",
        ...(data?.additional_fields || {}),
      },
    },
    validate: (values) => {
      let errors: any = {};
      if (!values.first_name) {
        errors.first_name = "Guest name is required";
      }

      if (!values.customer_visit_status) {
        errors.customer_visit_status = "Visit status is required";
      }

      if (!values.contact_number) {
        errors.contact_number = "Contact number is required";
      } else {
        const phoneValidation = validatePhoneNumber(
          values.country_code || country.dialCode,
          values.contact_number,
        );
        if (!phoneValidation.isValid) {
          errors.contact_number = phoneValidation.error;
        }
      }
      return errors;
    },
    onSubmit: (values) => {
      setSaveLoading(true);

      const payload = {
        ...values,
        company_outlet_uuid: company.comapny.company_outlet_uuid,
        additional_fields: {
          ...values.additional_fields,
          rating: rating,
        },
        customer_relative: [...relations],
        customer_name: (`${values?.first_name} ${values?.last_name ?? ""}`).trim(),
        name_of_guest: (`${values?.first_name} ${values?.last_name ?? ""}`).trim(),
      } as any;

      dispatch(
        upsertStudentAysnc(payload, (isSuccess) => {
          if (isSuccess) {
            if (buttonClicked === "save") {
              navigate(`${REACT_APP_NAV_ROUTES.customer}`);
            } else if (changeTab) {
              window.scrollTo(0, 0);
              changeTab(1);
            }
            if (onComplete) {
              onComplete();
            }
          }
          setSaveLoading(false);
        }),
      );
    },
  });

  // Initialize family data from existing values
  React.useEffect(() => {
    const outletId = company.comapny.company_outlet_uuid;

    if (customerId) {
      const customerIdStr = String(customerId);
      const currentCustomerId = data?.customer_fact_uuid
        ? String(data.customer_fact_uuid)
        : null;

      if (!currentCustomerId || currentCustomerId !== customerIdStr) {
        dispatch(fetchStudentAsync(customerIdStr, outletId));
      }
    }
  }, [customerId, data?.customer_fact_uuid, dispatch]);

  React.useEffect(() => {
    if (contact_number) {
      dispatch(
        fetchStudentAsync(
          undefined,
          company.comapny.company_outlet_uuid,
          contact_number,
        ),
      );
    }
  }, [contact_number, dispatch, company.comapny.company_outlet_uuid]);

  React.useEffect(() => {
    if (!data) return;

    if (customerId) {
      const customerIdStr = String(customerId);
      const dataCustomerId = data.customer_fact_uuid
        ? String(data.customer_fact_uuid)
        : null;

      if (dataCustomerId === customerIdStr) {
        setValues({
          ...data,
          customer_fact_uuid: customerIdStr,
        });
      }
    }

    if (data?.additional_fields) {
      const { relations, rating } = data.additional_fields;

      try {
        const parsedRelations = typeof relations === "string" ? JSON.parse(relations) : relations;

        if (Array.isArray(parsedRelations)) {
          setRelations([
            ...parsedRelations.map((item: any) => ({ ...item })),
            ...(data.customer_relative || []).map((item) => ({ ...item })),
          ]);
        } else {
          setRelations(
            (data.customer_relative || []).map((item) => ({ ...item })),
          );
        }
      } catch (e) {
        console.error("Error parsing relations:", e);
      }

      if (rating) {
        setRating(rating);
      }
    } else {
      setRelations(
        (data.customer_relative || []).map((item) => ({ ...item })),
      );
    }

    if (data?.contact_number) {
      const fullNumber = data.contact_number.trim();
      const match = fullNumber.match(/^(\+\d{1,3})(\d{10})$/);

      if (match) {
        const [, countryCode, phoneNumber] = match;

        const matchedCountry = COUNTRIES.find((c) => c.dialCode === countryCode);
        setValues((prev: any) => ({
          ...prev,
          contact_number: phoneNumber,
          country_code: countryCode,
          country_iso_code: matchedCountry?.code || country.code,
        }));
      }
    }
  }, [data, customerId, setValues]);

  //   React.useEffect(() => {
  //     if (data?.additional_fields) {
  //       // Initialize relations
  //       if (data.additional_fields.relations) {
  //         try {
  //           const parsedRelations =
  //             typeof data.additional_fields.relations === "string"
  //               ? JSON.parse(data.additional_fields.relations)
  //               : data.additional_fields.relations;
  //           if (Array.isArray(parsedRelations)) {
  //             // setRelations(parsedRelations.concat(data.customer_relative));
  //             setRelations([
  //               ...(parsedRelations || []).map((item: any) => ({ ...item })),
  //               ...(data.customer_relative || []).map((item) => ({ ...item })),
  //             ]);
  //           }
  //         } catch (e) {
  //           console.error("Error parsing relations data:", e);
  //         }
  //       }

  //       // Initialize rating
  //       if (data.additional_fields.rating) {
  //         setRating(data.additional_fields.rating);
  //       }
  //     }
  //     }, [data]);

  //   React.useEffect(() => {
  //     if (customerId) {
  //       const customerIdStr = String(customerId);
  //       const currentCustomerId = data?.customer_fact_uuid
  //         ? String(data.customer_fact_uuid)
  //         : null;
  //       if (!currentCustomerId || currentCustomerId !== customerIdStr) {
  //         dispatch(
  //           fetchStudentAsync(customerIdStr, company.comapny.company_outlet_uuid),
  //         );
  //       }
  //     }
  //   }, [customerId, dispatch, data?.customer_fact_uuid]);

  //   React.useEffect(() => {
  //     if (contact_number) {
  //       dispatch(
  //         fetchStudentAsync(
  //           undefined,
  //           company.comapny.company_outlet_uuid,
  //           contact_number,
  //         ),
  //       );
  //     }
  //   }, [dispatch, contact_number, company.comapny.company_outlet_uuid]);

  //   React.useEffect(() => {
  //     if (data && customerId) {
  //       const customerIdStr = String(customerId);
  //       const dataCustomerId = data.customer_fact_uuid ? String(data.customer_fact_uuid) : null;
  //       if (dataCustomerId === customerIdStr) {
  //         setValues({
  //           ...data,
  //           customer_fact_uuid: customerIdStr,
  //         });
  //         // setRelations(data.customer_relative);
  //         setRelations(
  //           (data.customer_relative || []).map((item) => ({
  //             ...item,
  //           })),
  //         );
  //       }
  //     }

  //   }, [data, customerId, setValues]);

  // React.useEffect(() => {
  //   if (data?.contact_number) {
  //     const fullNumber = data.contact_number.trim();

  //     const match = fullNumber.match(/^(\+\d{1,3})(\d{10})$/);

  //     if (match) {
  //       const [, countryCode, phoneNumber] = match;

  //       setSelectedCountryCode(countryCode);

  //       setValues((prev: any) => ({
  //         ...prev,
  //         contact_number: phoneNumber,
  //       }));
  //     }
  //   }
  // }, [data?.contact_number]);

  // Handler functions for relations
  const addRelation = () => {
    setRelations([
      ...relations,
      {
        relation_with_customer: "",
        customer_relative_name: "",
        event_name: "",
        event_uuid: "",
        function_date: "",
        company_outlet_uuid: company.comapny.company_outlet_uuid,
        status: "ACTIVE",
      },
    ]);
  };

  const handleSearchCustomer = () => {
    if (!values.contact_number || values.contact_number.length !== 10) {
      dispatch(
        showMessage({
          type: "error",
          displayAs: "snackbar",
          message: "Enter valid 10 digit contact number",
        }),
      );
      return;
    }

    const fullNumber = (values.country_code || country.dialCode) + values.contact_number;

    dispatch(
      fetchStudentAsync(
        undefined,
        company.comapny.company_outlet_uuid,
        values.contact_number,
        true,
        (isSuccess, data) => {
          if (data) {
            const match = values?.contact_number?.match(
              /^(\+\d{1,3})(\d{10})$/,
            );

            if (match) {
              const [, countryCode, phoneNumber] = match;
              const matchedCountry = COUNTRIES.find((c) => c.dialCode === countryCode);
              setValues((prev: any) => ({
                ...prev,
                country_code: countryCode,
                country_iso_code: matchedCountry?.code || country.code,
              }));
            }

            setValues({
              ...data,
              contact_number: data.contact_number.slice(-10),
              customer_fact_uuid: data.customer_fact_uuid,
            });

            dispatch(
              showMessage({
                type: "success",
                displayAs: "snackbar",
                message: "Customer found. Details loaded.",
              }),
            );
          } else {
            console.log("no found customer");
            setValues({
              ...defaultStudent,
              contact_number: values.contact_number,
            });

            dispatch(
              showMessage({
                type: "success",
                displayAs: "snackbar",
                message: "Customer not found. Creating new guest.",
              }),
            );
          }
        },
      ),
    );
  };

  const removeRelation = (index: number) => {
    setRelations(relations.filter((_, i) => i !== index));
  };

  // const updateRelation = (
  //   index: number,
  //   field: keyof ICustomerRelationEvent,
  //   value: string,
  // ) => {
  //   const updatedRelations = [...relations];
  //   updatedRelations[index][field] = value;
  //   setRelations(updatedRelations);
  // };

  const updateRelation = (
    index: number,
    field: keyof ICustomerRelationEvent,
    value: string,
  ) => {
    const updatedRelations = relations.map((item, i) => {
      if (i === index) {
        return {
          ...item, // ✅ clone object
          [field]: value, // ✅ update safely
        };
      }
      return item;
    });

    setRelations(updatedRelations);
  };

  const updateRelationObject = (
    index: number,
    value: ICustomerRelationEvent,
  ) => {

    setRelations(produce(relations, (draftState) => {
      draftState[index] = value
    }));
  };

  const isSearchNumberDisabled =
    !values.contact_number || !/^\d{10}$/.test(values.contact_number);

  return (
    <RightPanel
      open={open}
      heading={
        customerId || contact_number ? "Edit Guest Details" : "Add Guest"
      }
      topRightButtons={
        <RoleBasedCustomButton
          disabled={saveLoading}
          moduleId={MODULE_IDS.CUSTOMER}
          variant="contained"
          size="small"
          sx={{ border: "1px solid #fff" }}
          type="submit"
          onClick={() => {
            setButtonClicked("save");
            handleSubmit();
          }}
        >
          Save
        </RoleBasedCustomButton>
      }
      onClose={onClose}
      width="80%"
      actionButtons={() => (
        <Stack direction={"row"} spacing={3} justifyContent={"space-between"}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <RoleBasedCustomButton
            disabled={saveLoading}
            moduleId={MODULE_IDS.CUSTOMER}
            variant="contained"
            type="submit"
            onClick={() => {
              setButtonClicked("save");
              handleSubmit();
            }}
          >
            Save
          </RoleBasedCustomButton>
        </Stack>
      )}
    >
      <PageLoader loading={loading === LoadState.InProgress}>
        <form onSubmit={handleSubmit}>
          {/* Basic Information Section */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,

              mb: 2,
              position: "relative",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: "pointer", p: 2 }}
              onClick={() => toggleSection("basic")}
            >
              <PersonIcon />
              <Typography variant="h6" fontWeight={600}>
                Basic Information
              </Typography>

              <Box flexGrow={1} />

              <IconButton size="small">
                {openSection === "basic" ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Stack>

            <Collapse in={openSection === "basic"}>
              <Grid container spacing={2} p={2} pt={0}>
                {/* <Grid item xs={12} lg={3} sx={{ display: "flex", gap: 1 }}>
                  <CountryCodeSelect
                    label={""}
                    sx={{ width: "80px" }}
                    value={selectedCountryCode}
                    onChange={(value) => setSelectedCountryCode(value)}
                  />

                  <GuestContactNumberAutoSearch
                    label="Contact Number"
                    value={values.contact_number}
                    onInputValueChange={(val) => {
                      setValues({
                        ...defaultStudent,
                        contact_number: val,
                      });
                    }}
                    onSelect={(customer) => {
                      if (customer?.contact_number) {
                        const fullNumber = customer.contact_number.trim();

                        // Extract country code + last 10 digits
                        const match = fullNumber.match(/^(\+\d{1,3})(\d{10})$/);

                        if (match) {
                          const [, countryCode, phoneNumber] = match;

                          setSelectedCountryCode(countryCode);

                          setValues({
                            ...customer,
                            contact_number: phoneNumber, // ONLY last 10 digits
                            customer_fact_uuid: customer.customer_fact_uuid,
                          });
                        }
                      } else {
                        setValues({
                          ...defaultStudent,
                          contact_number: values.contact_number,
                        });
                      }
                    }}
                    error={errors.contact_number as string}
                  />
                </Grid> */}

                <Grid item xs={12} lg={3} sx={{ display: "flex", gap: 1 }}>
                  <Box sx={{ maxWidth: 90 }}>
                    <CountryCodeSelector
                      sx={{
                        minHeight: 36,
                      }}
                      value={values.country_iso_code || ""}
                      onChange={(newCountry) => {
                        setValues((prev) => ({
                          ...prev,
                          country_code: newCountry.dialCode,
                          country_iso_code: newCountry.code,
                        }));
                      }}
                    />
                  </Box>

                  <PhoneTextField
                    label="Contact Number *"
                    value={values.contact_number}
                    fullWidth
                    onChange={(value: string) => {
                      setFieldValue("contact_number", value);
                    }}
                    InputProps={{
                      endAdornment: values.contact_number ? (
                        <InputAdornment position="end">
                          <IconButton
                            disabled={isSearchNumberDisabled}
                            sx={{
                              bgcolor: "primary.main",
                              color: "#fff",
                              borderRadius: "10px",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                bgcolor: "primary.main",
                                opacity: 0.9,
                              },
                              "&.Mui-disabled": {
                                bgcolor: "grey.400",
                                color: "#fff",
                              },
                            }}
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSearchCustomer();
                            }}
                            edge="end"
                            title="Search phone number"
                          >
                            <Search fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : undefined,
                    }}
                    error={!!errors.contact_number}
                    helperText={errors.contact_number}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="First Name"
                    name="first_name"
                    variant="outlined"
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.first_name}
                    error={errors.first_name ? true : false}
                    helperText={errors.first_name}
                    onChange={handleChange}
                    placeholder="Enter first name"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="Last Name"
                    name="last_name"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.last_name}
                    error={errors.last_name ? true : false}
                    helperText={errors.last_name}
                    onChange={handleChange}
                    placeholder="Enter last name"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    data-prevent-toggle
                    label="Email"
                    name="email"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.email}
                    error={errors.email ? true : false}
                    helperText={errors.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomDatePicker
                    placeholder="Guest Birthday"
                    views={["month", "day"]}
                    inputFormat="DD-MM"
                    value={values.date_of_birth || ""}
                    onChange={(newValue) => {
                      setFieldValue("date_of_birth", newValue);
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomDatePicker
                    placeholder="Anniversary"
                    views={["month", "day"]}
                    inputFormat="DD-MM"
                    value={values.additional_fields?.anniversary || ""}
                    onChange={(newValue) => {
                      setFieldValue("additional_fields", {
                        ...(values.additional_fields || {}),
                        anniversary: newValue,
                      });
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="Spouse Name"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.additional_fields?.spouse_name || ""}
                    onChange={(e) =>
                      setFieldValue("additional_fields", {
                        ...(values.additional_fields || {}),
                        spouse_name: e.target.value,
                      })
                    }
                    placeholder="Enter Spouse name"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomDatePicker
                    placeholder="Spouse Birthday"
                    views={["month", "day"]}
                    inputFormat="DD-MM"
                    value={values.additional_fields?.spouse_birthday || ""}
                    onChange={(newValue) => {
                      setFieldValue("additional_fields", {
                        ...(values.additional_fields || {}),
                        spouse_birthday: newValue,
                      });
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <ControlledCustomSelect
                    fullWidth
                    name="customer_visit_status"
                    label="Guest Interaction *"
                    value={values.customer_visit_status}
                    error={errors.customer_visit_status ? true : false}
                    helperText={errors.customer_visit_status}
                    displayEmpty
                    // renderValue={renderDropdownValue(`Choose bulk Action`)}
                    onChange={(e) =>
                      setFieldValue("customer_visit_status", e.target.value)
                    }
                    options={GuestInteractionStatusOptions}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <Typography variant="body2">Gender</Typography>
                    <RadioGroup
                      row
                      name="gender"
                      value={values.gender}
                      onChange={(e) => setFieldValue("gender", e.target.value)}
                    >
                      <FormControlLabel
                        value="MALE"
                        control={<Radio />}
                        label="Male"
                      />
                      <FormControlLabel
                        value="FEMALE"
                        control={<Radio />}
                        label="Female"
                      />
                      <FormControlLabel
                        value="OTHER"
                        control={<Radio />}
                        label="Other"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Collapse>
          </Box>

          {/* Address Information Section */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,

              mb: 2,
              position: "relative",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: "pointer", p: 2 }}
              onClick={() => toggleSection("address")}
            >
              <LocationOnIcon />
              <Typography variant="h6" fontWeight={600}>
                Address Information
              </Typography>

              <Box flexGrow={1} />

              <IconButton size="small">
                {openSection === "address" ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Stack>

            <Collapse in={openSection === "address"}>
              <Grid container spacing={2} p={2} pt={0}>
                <Grid item xs={12} lg={12}>
                  <LocationAutoCompleteWithManualAddress
                    id={`company-address`}
                    variant="outlined"
                    size="small"
                    type="text"
                    fullWidth
                    value={formatCompanyAddress({
                      line1: values.address_line1,
                      line2: values.address_line2,
                      city: values.city,
                      state: values.state,

                      country: values.country,
                      postalCode: values.pincode,
                    })}
                    onLocationChange={(data) =>
                      handleCompanyAddressChange(data)
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="City"
                    id="city"
                    variant="outlined"
                    fullWidth
                    value={values.city || ""}
                    onChange={handleChange}
                    placeholder="City"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="Country"
                    id="country"
                    variant="outlined"
                    fullWidth
                    value={values.country || ""}
                    onChange={handleChange}
                    placeholder="country"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="State"
                    id="state"
                    variant="outlined"
                    fullWidth
                    value={values.state || ""}
                    onChange={handleChange}
                    placeholder="State"
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <CustomTextField
                    label="Pincode"
                    id="pincode"
                    variant="outlined"
                    fullWidth
                    value={values.pincode || ""}
                    onChange={handleChange}
                    placeholder="Pincode"
                  />
                </Grid>
              </Grid>
            </Collapse>
          </Box>

          {/* Relations Information Section */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,

              mb: 2,
              position: "relative",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: "pointer", p: 2 }}
              onClick={() => toggleSection("relations")}
            >
              <PeopleIcon />
              <Typography variant="h6" fontWeight={600}>
                Relations Information
              </Typography>
              <Box flexGrow={1} />
              <Button
                variant="contained"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  addRelation();
                  setOpenSection("relations");
                }}
                startIcon={<span>+</span>}
              >
                {isMobile ? "Add" : "Add Details"}
              </Button>

              <IconButton size="small">
                {openSection === "relations" ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Stack>

            <Collapse in={openSection === "relations"}>
              {relations.length > 0 && (
                <Box p={2} pt={0}>
                  {relations.map((relation, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: index < relations.length - 1 ? 2 : 0,
                        pb: index < relations.length - 1 ? 2 : 0,
                        borderBottom:
                          index < relations.length - 1
                            ? "1px solid #e0e0e0"
                            : "none",
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={3}>
                          <RelationAutoSearch
                            label="Relation with customer"
                            value={relation.relation_with_customer || ""}
                            onChange={(value) =>
                              updateRelation(
                                index,
                                "relation_with_customer",
                                value,
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <CustomTextField
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label={
                              relation.relation_with_customer
                                ? `${relation.relation_with_customer}'s Name`
                                : "Name"
                            }
                            variant="outlined"
                            fullWidth
                            value={relation.customer_relative_name}
                            onChange={(e) =>
                              updateRelation(
                                index,
                                "customer_relative_name",
                                e.target.value,
                              )
                            }
                            placeholder="Enter name"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3}>
                          <EventAutoSearch
                            label="Occasion"
                            value={relation.event_name}
                            allowedEvents={["Birthday", "Anniversary"]}
                            onSelect={(event_type: any, event_uuid: any, event_name: any) => {
                              updateRelationObject(index, {
                                ...relation,
                                event_uuid: event_uuid,
                                event_name: event_name
                              })
                            }}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} lg={2.5}>
                          <CustomDatePicker
                            placeholder="Occasion Date"
                            views={["month", "day"]}
                            inputFormat="DD-MM"
                            value={relation.function_date}
                            onChange={(newValue) =>
                              updateRelation(
                                index,
                                "function_date",
                                newValue || "",
                              )
                            }
                            fullWidth
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          lg={0.5}
                          sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeRelation(index);
                            }}
                            sx={{ color: "error.main" }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </Box>
              )}

              {relations.length === 0 && (
                <Box
                  sx={{
                    textAlign: "center",
                    py: 3,
                    color: "text.secondary",
                  }}
                >
                  <Typography variant="body2">
                    No relations added yet. Click "Add Details" to add family
                    relations.
                  </Typography>

                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      addRelation();
                      setOpenSection("relations");
                    }}
                    startIcon={<span>+</span>}
                  >
                    Add Details
                  </Button>
                </Box>
              )}
            </Collapse>
          </Box>

          {/* Reviews / Comments */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,

              mb: 2,
              position: "relative",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: "pointer", p: 2 }}
              onClick={() => toggleSection("ratings")}
            >
              <AppShortcutIcon />
              <Typography variant="h6" fontWeight={600}>
                Ratings
              </Typography>
              <Box flexGrow={1} />
              <IconButton size="small">
                {openSection === "ratings" ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Stack>

            <Collapse in={openSection === "ratings"}>
              <Grid container spacing={2} p={2} pt={0}>
                <Grid item xs={12}>
                  <Rating
                    name="customer-rating"
                    value={rating}
                    onChange={(event, newValue) => {
                      setRating(newValue || 0);
                    }}
                    size="large"
                    icon={<StarIcon fontSize="inherit" />}
                    emptyIcon={<StarIcon fontSize="inherit" />}
                    sx={{
                      "& .MuiRating-iconFilled": {
                        color: "#ffc107",
                      },
                      "& .MuiRating-iconEmpty": {
                        color: "#e0e0e0",
                      },
                      "& .MuiRating-iconHover": {
                        color: "#ffcd38",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Reviews"
                    id="remarks"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={3}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.remarks || ""}
                    onChange={handleChange}
                    placeholder="Write your review or comments here..."
                  />
                </Grid>
              </Grid>
            </Collapse>
          </Box>
        </form>
      </PageLoader>
    </RightPanel>
  );
};
